/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars */
import { useRegExpMask } from '../index.js';
import type { UseRegExpMaskT } from '../index.js';

// test we expose the namespace and the namespace follows our deliverable conventions
type ComponentPropsForApp = UseRegExpMaskT.Props;
type ComponentPropsInternals = UseRegExpMaskT.InternalProps;
type ComponentPropsDefaultProps = UseRegExpMaskT.DefaultProps;
type ComponentPropsOptionalProps = UseRegExpMaskT.OptionalProps;
type ComponentPropsRequiredProps = UseRegExpMaskT.RequiredProps;

const regExp = ['+(', /[0-9]/, /[0-9]/, ') ', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/];

const testRequiredProps: ComponentPropsRequiredProps = {
  valueSetter: () => {},
  regExp,
};

const testOptionalProps: ComponentPropsOptionalProps = {};

// difference Props and InternalProps is that InternalProps has all the default props filled in
// Props allows for partial defaults
const testPartialDefaults: Partial<ComponentPropsDefaultProps> = {
  onChange: () => {},
  filledMask: false,
};

const testProps: ComponentPropsForApp = {
  ...testRequiredProps,
  ...testOptionalProps,
  ...testPartialDefaults,
};

const testPropsAsSyntax = {
  ...testRequiredProps,
  ...testOptionalProps,
  ...testPartialDefaults,
} as ComponentPropsForApp;

// InternalProps requires all defaults to be filled in
const testCompleteDefaults: Required<ComponentPropsDefaultProps> = {
  onChange: () => {},
  onKeyDown: () => {},
  onBlur: () => {},
  filledMask: true,
};

const testInternalProps: ComponentPropsInternals = {
  ...testRequiredProps,
  ...testOptionalProps,
  ...testCompleteDefaults,
};

const testInternalPropsAsSyntax = {
  ...testRequiredProps,
  ...testOptionalProps,
  ...testCompleteDefaults,
} as ComponentPropsInternals;

// using the explicit type definition, if there is an error, it will be marked on the key that is wrong
const testExplicitDefinition: ComponentPropsForApp = {
  valueSetter: () => {},
  regExp,
  onChange: () => {},
  onKeyDown: () => {},
  onBlur: () => {},
  filledMask: true,
};

// using the "as" syntax, if there is an error, it will be marking the whole object as wrong because it is not compatible with the type
const testInferedTypeCompatibility = {
  valueSetter: () => {},
  regExp,
  onChange: () => {},
  onKeyDown: () => {},
  onBlur: () => {},
  filledMask: true,
} as ComponentPropsForApp;

const testDefinitionAsConst = {
  valueSetter: () => {},
  regExp,
  onChange: () => {},
  onKeyDown: () => {},
  onBlur: () => {},
  filledMask: true,
} as const;

const ExampleUsageComponent = () => {
  // works with explicitly casted props, all syntaxes
  const inputProps = useRegExpMask({
    ...testExplicitDefinition,
  });
  const inputProps2 = useRegExpMask({
    ...testInferedTypeCompatibility,
  });
  const inputProps3 = useRegExpMask({
    ...testDefinitionAsConst,
  });
  // works with inline values
  const { onChange, onKeyDown, onBlur } = useRegExpMask({
    valueSetter: () => {},
    regExp: [],
    onChange: () => {},
    onKeyDown: () => {},
    onBlur: () => {},
    filledMask: true,
  });

  return <div></div>;
};
